import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

function Timer({ time }) {
  const [remaining, setRemaining] = useState("");

  useEffect(() => {
    const target = dayjs(time);
    const now = dayjs();

    if (target.isBefore(now)) {
      setRemaining("Expired");
      return; // ❌ Exit early: Don't run setInterval
    }

    const updateCountdown = () => {
      const now = dayjs();
      const diff = target.diff(now);
      const d = dayjs.duration(diff);

      if (d.asHours() >= 24) {
        setRemaining(`Time Left : ${Math.floor(d.asDays())}d ${d.hours()}h ${d.minutes()}m ${d.seconds()}s`);
      } else {
        const h = String(d.hours()).padStart(2, "0");
        const m = String(d.minutes()).padStart(2, "0");
        const s = String(d.seconds()).padStart(2, "0");
        setRemaining(`Time Left : ${h}:${m}:${s}`);
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [time]);

  return (
    <div className="mybookings--cta--list">
      <ul className="mybookings--cta--list--internal">
        <li>{remaining}</li>
      </ul>
    </div>
  );
}

export default Timer;
